module.exports = __webpack_public_path__ + "img/collaborate_6.efaf413e.jpg";